export const QUERY_PARAM = "search_query"
export const PAGE_PARAM = "p"
export const SIZE_PARAM = "size"
export const FILTER_PREFIX = "filter."
export const SORT_PARAM = "sort"
